import { useTranslation } from 'react-i18next';
import BrowserIcon from 'src/assets/icons/BrowserIcon';
import useAuth from 'src/hooks/useAuth';

const PunchoutSessionInfo = () => {
  const { t } = useTranslation();
  const { siteName } = useAuth();

  return (
    <div
      data-testid="punchout-session-info"
      className="flex h-full min-h-0 w-full flex-col items-center justify-center px-4 text-center"
    >
      <BrowserIcon width={60} height={60} />
      <h1 className="mt-8 text-2xl font-semibold text-black">
        {t('punchoutSessionNewTab')}
      </h1>
      <p className="mt-4 text-base font-normal text-black">{t('punchoutAllowPopup')}</p>
      <p className="mt-2 max-w-2xl text-base font-normal text-black">
        {t('punchoutSessionDone', { siteName })}
      </p>
    </div>
  );
};

export default PunchoutSessionInfo;
